import { NavItem } from "@components/Settings/NavItem";
import { WithPermission } from "@components/WithPermission";
import { settingsRoutes } from "@constants/routes";
import { toFeatureList } from "@lyteflo/utils";
import { useTranslation } from "react-i18next";

export const Nav = () => {
  const { t } = useTranslation();
  return (
    <nav className="lf-w-full lf-flex lf-flex-col lf-gap-1">
      {settingsRoutes.map(
        ({
          path,
          labelKey,
          icon: Icon,
          iconClassName,
          iconColorClassName,
          feature,
          requiredLevel,
          hidden,
        }) => {
          if (hidden) return null;
          return (
            <WithPermission
              key={path}
              features={toFeatureList(feature)}
              requiredLevel={requiredLevel}
            >
              <NavItem
                path={path}
                label={t(labelKey)}
                Icon={Icon}
                iconClassName={iconClassName}
                iconColorClassName={iconColorClassName}
              />
            </WithPermission>
          );
        },
      )}
    </nav>
  );
};
